import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpGetUserMe } from "~/services/http/users";

export const fetchUserMeAsync = createAsyncThunk(
  "users/fetchUserMe",
  async (company_id, { rejectWithValue }) => {
    try {
      return await httpGetUserMe(company_id);
    } catch (error) {
      return rejectWithValue({
        statusCode: error.status,
      });
    }
  },
);

const usersSlice = createSlice({
  name: "users",
  initialState: { data: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserMeAsync.fulfilled, (state, action) => {
      state.data.me = action.payload;
    });
  },
});

export const getUserMe = (company_id) => (dispatch) =>
  dispatch(fetchUserMeAsync(company_id)).unwrap();

export default usersSlice.reducer;
